import kURL from 'kurl';

const HTTP_PROTOCOL = 'http';
const HTTPS_PROTOCOL = 'https';

export default angular.module('installer.url-helper', []).
  factory('urlHelper', () => ({
    getProtocolAndHostFromUrl(url) {
      return kURL(url).select('protocol', 'hostname');
    },
    getHostOfUrl(url) {
      return kURL(url).select('hostname');
    },
    getPortOfUrl(url) {
      return kURL(url).attr('port');
    },
    changePortInUrl(baseUrl, newPort) {
      const kurl = kURL(baseUrl);
      let actualPortInUrl = newPort;
      if (kurl.select('protocol') === `${HTTP_PROTOCOL }://` && newPort === '80' ||
        kurl.select('protocol') === `${HTTPS_PROTOCOL }://` && newPort === '443') {
        actualPortInUrl = '';
      }
      kurl.attr('port', actualPortInUrl);
      return kurl.href();
    },
    addProtocolIfNotExist: url => {
      const kurl = kURL(url);
      if (!kurl.attr('protocol')) {
        kurl.attr('protocol', HTTP_PROTOCOL);
        kurl.href();
      }
      return kurl.href();
    },
    changeHostInUrl(baseUrl, newHost) {
      const kurl = kURL(baseUrl);
      kurl.attr('hostname', newHost);
      return kurl.href();
    }
  }));



// WEBPACK FOOTER //
// ./src/blocks/url-helper/url-helper.js